import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import NewSignUp from "./pages/newsignup";
import SignUp from "./pages/signup";
import { SignIn } from "./pages/signin";
import ForgotPassword from "./pages/forgot_password";
import Payments from "./pages/payment";
import PaymentCallback from "./pages/paymentCallback";
import FindADoctor from "./pages/find-a-doctor/find-a-doctor";
import VisitsAndAppointments from "./pages/visits_and_appointments/visits_and_appointments";
import LabInvestigations from "./pages/lab_investigations";
import Prescriptions from "./pages/prescriptions";
import Announcements from "./pages/announcements";
import DoctorProfile from "./pages/find-a-doctor/doctor_profile";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import VerifyOTP from "./pages/verify-otp";
import SelectOTPPhone from "./pages/select-otp-phone-number";
import OTPInputScreen from "./pages/otp-input-screen";
import SetNewPasswordScreen from "./pages/set-new-password";
import { useReduxDispatch } from './redux/hooks';
import { initializeFromStorage } from './redux/slice/UserSlice';
import Settings from "./pages/settings";
import { Toaster } from 'sonner';
import PrivacyPolicy from "./pages/privacy_policy";
import { AppLayout } from './components/AppLayout';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      refetchOnMount: false,
      refetchOnReconnect: "always",
      staleTime: Infinity,
    }
  },
});

function App() {
  const dispatch = useReduxDispatch();

  useEffect(() => {
    const userSession = localStorage.getItem('@user-session');
    if (userSession) {
      dispatch(initializeFromStorage());
    }
  }, [dispatch]);

  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <Toaster
          position="top-right"
          toastOptions={{
            unstyled: true,
            classNames: {
              toast: 'rounded-lg shadow-lg p-4',
              title: 'font-semibold text-sm',
              description: 'text-sm mt-1',
            }
          }}
        />
        <Routes>
          {/* Non-authenticated routes */}
          <Route path="/newsignup" element={<NewSignUp />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/verify-otp" element={<VerifyOTP />} />
          <Route path="/select-otp-phone-number" element={<SelectOTPPhone />} />
          <Route path="/otp-input" element={<OTPInputScreen />} />
          <Route path="/set-new-password" element={<SetNewPasswordScreen />} />
          <Route path="/forgot_password" element={<ForgotPassword />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/payment-callback" element={<PaymentCallback />} />

          {/* Public routes with layout */}
          <Route path="/" element={
            <AppLayout requireAuth={false}>
              <Home />
            </AppLayout>
          } />
          <Route path="/find-a-doctor" element={
            <AppLayout requireAuth={false}>
              <FindADoctor />
            </AppLayout>
          } />
          <Route path="/doctor-profile" element={
            <AppLayout requireAuth={false}>
              <DoctorProfile />
            </AppLayout>
          } />
          <Route path="/visits-and-appointments" element={
            <AppLayout>
              <VisitsAndAppointments />
            </AppLayout>
          } />
          <Route path="/lab-investigations" element={
            <AppLayout>
              <LabInvestigations />
            </AppLayout>
          } />
          <Route path="/prescriptions" element={
            <AppLayout>
              <Prescriptions />
            </AppLayout>
          } />
          <Route path="/announcements" element={
            <AppLayout>
              <Announcements />
            </AppLayout>
          } />
          <Route path="/settings" element={
            <AppLayout>
              <Settings />
            </AppLayout>
          } />
        </Routes>
        <ReactQueryDevtools initialIsOpen={true} position="bottom" />
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export default App;

// 
// 0296208
// f00b@r$$

// TODO
// forgot password is stuck on loading on error
// export ANTHROPIC_API_KEY=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
// Listen to SSE and show loading, error or success modal